import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";

import Rendertable from "./Rendertable";
import { getProductSearchResultforsales, updateAuditQuantity, getAuditReport, resetAuditQuantity, saveAuditReport } from "../../../actions/productDetails";
import {
  getAllLocation,
  getAllLocationPlain,
} from "../../../actions/warehouseAction";
import { getAllCategory } from "../../../actions/categoryAction";
import { getAllAttributeTerm , getAllAttribute  } from "../../../actions/attributeAction";

import {
  Divider,
  AutoComplete,
  Row,
  Col,
  Select,
  Skeleton,
  TreeSelect,
  Button,
  InputNumber,
  Checkbox,
  Form,
  Card
} from "antd";
const { Option } = Select;

const SearchStock = ({
  getProductSearchResultforsales,
  getAllLocation,
  getAllLocationPlain,
  categoryList,
  getAllCategory,
  getAllAttributeTerm,
  attributeTerms,
  getAllAttribute,
  attributes,
  updateAuditQuantity,
  getAuditReport,
  resetAuditQuantity,
  saveAuditReport,
}) => {
  const [List, setList] = useState([]);
  const BarcodeInput = useRef(null);
  const [locations, setLocations] = useState([]);
  const [reload, setreload] = useState(false);
  const [reset, setreset] = useState(false);
  const [loading, setloading] = useState(false);
  const [updatedstock, setupdatedstock] = useState(null);
  const [auditReport, setauditReport] = useState([]);
  const location = useRef("");
  const keyward = useRef("");
  const pageno = useRef(1);
  const page_size = useRef(10);
  const increament_by = useRef(1);
  let total_data = useRef({});
  const searchCategory = useRef("");
  const searchAttribute = useRef("");
  const lowrange = useRef("");
  const heighrange = useRef("");
  const zeroStock = useRef(false);
  const [form] = Form.useForm();


  const onChange = (event) => {
    if (event.keyCode == 13) {
      pageno.current = 1;
      keyward.current = event.target.value;
      setreload(!reload);
    }else{
      if(event.target.value == ""){
        pageno.current = 1;
        keyward.current = event.target.value;
        setreload(!reload);
      }
    }
  };

  useEffect(() => {
    getAllCategory();
    getAllAttributeTerm();
    getAllAttribute();
    getAllLocationPlain().then((result) => {
      setLocations(result);
    });
  }, []);


  useEffect(() => {
    if(keyward.current !== ""){
      setloading(true);
      getProductSearchResultforsales(
        keyward.current,
        location.current,
        pageno.current,
        page_size.current,
        searchCategory.current,
        searchAttribute.current,
        lowrange.current,
        heighrange.current,
        zeroStock.current
      ).then((result) => {
        if(result.count == 1){
          let formdata = new FormData();
          formdata.append("id", result.results[0].id);
          formdata.append("increament_by", 1);
          updateAuditQuantity(formdata).then(res => {
            setupdatedstock(res)
            keyward.current = ""
            
            form.resetFields()
            setloading(false);
            setreset(!reset);
            setTimeout(() => {
              BarcodeInput.current.focus();
            }, 0);
            
            // getAuditReport().then(report => {
            //   setauditReport(report);
            //   setloading(false);
            // })
          })
          
        }else{
          // setloading(false);
          // BarcodeInput.current.focus();
          // alert(keyward.current)
          let formdata = new FormData();
          formdata.append("keyword", keyward.current);
          // formdata.append("increament_by", 1);
          formdata.append("location", location.current);
          updateAuditQuantity(formdata).then(res => {
            // console.log(res)
            setupdatedstock(res)
            keyward.current = ""
            form.resetFields()
            setloading(false);
            setreset(!reset);
            setTimeout(() => {
              BarcodeInput.current.focus();
            }, 0);
          })
        }
      });
    }
  }, [reload]);

  useEffect(() => {
    
      getAuditReport(location.current).then(report => {
        setauditReport(report);
      })
  }, [reset]);



  const renderdata = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      // console.log(updatedstock)
      // return "Puki"
      if (updatedstock) {
        return updatedstock.map(stock => {
          let style = {border: "1px solid #eee", padding: "12px", borderRadius: "4px"}
          if(stock.current_entry){
            style = {border: "1px solid #eee", padding: "12px", borderRadius: "4px", backgroundColor: "#daffd5"}
          }
          return <>
            <Col span={12} style={style}>
        
              <Row>
                  <Col span={6}>
                    {stock.product_code}<br></br>
                    Batch: <b>{stock.batch_no}</b><br></br>
                    Barcode: {stock.barcode}<br></br>
                    Location: {stock.Warehouse_name}<br></br>
                    Variation: <b>{stock.size}</b>
                  </Col>
                  <Col span={3} style={{textAlign: "center"}}>
                  Inventory
                  <h1>{stock.quantity}</h1>
                  </Col>
                  <Col span={3} style={{textAlign: "center"}}>
                  Audit
                  {stock.quantity == stock.audit_quantity && <h1 style={{color: "#43e131ff"}}>{stock.audit_quantity}</h1>}
                  {stock.quantity > stock.audit_quantity && <h1 style={{color: "red"}}>{stock.audit_quantity}</h1>}
                  {stock.quantity < stock.audit_quantity && <h1 style={{color: "orange"}}>{stock.audit_quantity}</h1>}
                  </Col>
                  <Col span={4} style={{margin: "auto"}}>
                    Add new stock
                    <InputNumber  min={0} onChange={(e) =>{
                      increament_by.current = e;
                      setreset(!reset);
                    }}>
                    </InputNumber>
                    <Button onClick={()=>{
                        let formdata = new FormData();
                        formdata.append("id", stock.id);
                        formdata.append("increament_by", increament_by.current);
                        updateAuditQuantity(formdata).then(res => {
                          setupdatedstock(res)
                          keyward.current = ""
                          form.resetFields()
                          setloading(false);
                          setreset(!reset);
                          BarcodeInput.current.focus();
                          increament_by.current = 0;
                          // setTimeout(() => {
                            
                          // }, 0);
                        });
                    }}>Submit</Button>
                  </Col>

              </Row>
              
            </Col>
          </>
        })
       
      } else{
        return (<div style={{border: "1px solid #eee", padding: "12px", borderRadius: "4px"}}> No Data Found</div>);
      }
    }
  };

  const renderSummary = () => {
    if (auditReport) {
      return <div > 
            <Row>
                <Col span={3}>
                  <Card>
                    <h3>Total Inventory</h3>
                    <h1>{auditReport.total_quantity}</h1>
                  </Card>
                </Col>
                <Col span={3}>
                  <Card>
                    <h3>Count</h3>
                    <h1>{auditReport.total_audit_quantity}</h1>
                  </Card>
                </Col>
                <Col span={3}>
                  <Card>
                    <h3>Remaining</h3>
                    <h1>{auditReport.remaining}</h1>
                  </Card>
                </Col>
                
                <Col span={3}>
                  <Card>
                    <h3>Total Variation</h3>
                    <h1>{auditReport.total_variation_count}</h1>
                  </Card>
                </Col>
                
                <Col span={3}>
                  <Card>
                    <h3>Healthy in Audit</h3>
                    <h1>{auditReport.good_audit_count}</h1>
                  </Card>
                </Col>
                <Col span={3}>
                  <Card>
                    <h3>Missing in Audit</h3>
                    <h1>{auditReport.missing_audit_count}</h1>
                  </Card>
                </Col>
                <Col span={3}>
                  <Card>
                    <h3>Excess in Audit</h3>
                    <h1>{auditReport.excess_audit_count}</h1>
                  </Card>
                </Col>
            </Row>
          </div>;
    }
  }

  return (
    <>
      <Row>
        <Col span={6}>
          {/* <h3>Choose Location</h3> */}
          <Select
            placeholder="Please Select Location"
            style={{ width: "100%" }}
            onChange={(e) => {
              location.current = e;
              pageno.current = 1;
              keyward.current = "";
              setupdatedstock(null);
              setreload(!reload);
              setreset(!reset);
            }}
          >
            <Option value="">All</Option>
            {locations.map((outlet) => {
              return <Option value={outlet.id}>{outlet.name}</Option>;
            })}
          </Select>
        </Col>
        <Col span={6}>  
        </Col>
        <Col>
        
          <Button type="danger" onClick={() => {
            if(location.current != ""){
              resetAuditQuantity(location.current).then(res => {
                setreset(!reset)
              })
            }else{
              alert("Please select a location")
            }
            }}>
            Reset
          </Button>
        </Col>
        <Col>
        <Button type="primary" style={{marginLeft: "10px"}} onClick={()=>{
          if(location.current != ""){
            let formdata = new FormData();
            formdata.append("location", location.current);
            saveAuditReport(formdata).then(res=> {
              alert("report has been saved")
            })
          }else{
            alert("Please select a location")
          }
        }}>Save Audit Report</Button>
        </Col>
      </Row>
      <Divider />
      {renderSummary()}
      
      <Divider />
      <Row>
        <Col span={24}>
          <h3>Enter Product Barcode for Search</h3>
          <Form form={form} layout="vertical">
              <Form.Item name="remarks" label="">
                  <AutoComplete
                    ref={BarcodeInput}
                    placeholder="input search text"
                    // onChange={onChange}
                    onKeyUp={onChange}
                    style={{ width: "100%" }}
                  />
              </Form.Item>
          </Form>
        </Col>
      </Row>
          
      <Divider />
      
      <Row>{renderdata()}</Row>
      
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    // List: state.ProductDetails.productdetails,
    categoryList: state.category.categorylist,
    attributeTerms: state.attribute.attributeTerms,
    attributes: state.attribute.attributelist,
  };
};

export default connect(mapStateToProps, {
  getProductSearchResultforsales,
  getAllLocation,
  getAllLocationPlain,
  getAllCategory,
  getAllAttributeTerm,
  getAllAttribute,
  updateAuditQuantity,
  getAuditReport,
  resetAuditQuantity,
  saveAuditReport,
})(SearchStock);
